/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { ERR_PROCESSING_REQ } from '../../../../SharedModules/AppConstants';
import { RadioGroupComponentDLP } from './RadioGroupComponentDLP';
import { formatQuater } from '../../../Display/Claim/store/action';
import { NDCDetailsTextFieldComponent } from '../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import {
  getRequestDrugPriceLoadFileUpload,
  getRequestDrugPriceLoadMaxQuarterForFreezeDt,
  getRequestDrugPriceLoadValidateFrozenInvoice,
  getRequestDrugPriceLoadPriceTypeDetails,
  getRequestDrugPriceLoadRebateProgramCode,
  getRequestDrugPriceLoadUserDefaults,
  setPriceLoadDetailsFilter,
  setSearchFilter,
} from '../store/action';
import {
  dataContentRadioData,
  dataSourceRadioData,
  multiPriceSelectionRadioData,
  planTypeRadioData,
  validateHeaderFields,
} from '../utils/constant';
import { checkQuaterIsValid } from './RequestDrugPriceLoadManufactureTable';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  PRICE_TYPE_REQUIRED,
  REBATE_PROGRAM_REQUIRED_REQ,
} from '../../../../SharedModules/Errors/constantMessageData';

const ReuestDrugPriceLoadSearchComponent = ({
  navigateToPage,
  searchFilter,
  setErrorMessages,
  setFieldError,
  setSuccessMessages,
  fieldError,
  errorMessages,
  isEnablebyRole = true,
}) => {
  const [quater, setQuater] = useState(null);
  const dispatch = useDispatch();

  const defaultQtrRDP = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.defaultQtrRDP
  );

  const userDefault = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const priceTypeData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceTypeData
  );
  const rebateProgramData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.rebateProgramData
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const [file, setFile] = useState(null);
  const [uploadMfgId, setUploadMfgId] = useState(null);
  const fileInputRef = useRef();

  useEffect(() => {
    dispatch(getRequestDrugPriceLoadMaxQuarterForFreezeDt());
    dispatch(getRequestDrugPriceLoadPriceTypeDetails());
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    if (!searchFilter.calcQtr && defaultQtrRDP) {
      setQuater(defaultQtrRDP);
      dispatch(setSearchFilter('calcQtr', defaultQtrRDP));
    } else if (searchFilter.calcQtr) {
      setQuater(searchFilter.calcQtr);
      dispatch(setSearchFilter('calcQtr', searchFilter.calcQtr));
    }
  }, [defaultQtrRDP]);

  useEffect(() => {
    if (searchFilter && searchFilter.planType) {
      dispatch(getRequestDrugPriceLoadRebateProgramCode(searchFilter.planType));
    }
  }, [searchFilter && searchFilter.planType]);

  useEffect(() => {
    if (!searchFilter || !searchFilter.rpc) {
      if (rebateProgramData && rebateProgramData.length > 0 && userDefault) {
        const filterArr = rebateProgramData.filter(
          (item) => item.value === userDefault.rebateProgramCd
        );

        if (filterArr.length > 0) {
          dispatch(setSearchFilter('rpc', filterArr[0].value));
          dispatch(setSearchFilter('checkPayeeCd', filterArr[0].checkPayeeCd));
        }
      }
    }
  }, [rebateProgramData, userDefault]);

  useEffect(() => {
    if (userDefault && userDefault.planTypeCd && !searchFilter.planType) {
      dispatch(
        setSearchFilter(
          'planType',
          userDefault.planTypeCd === 'FD'
            ? planTypeRadioData[0].value
            : userDefault.planTypeCd
        )
      );
    }
  }, [userDefault]);

  const hanldeFileUpload = ((e) => {
    const file = e.currentTarget.files?.[0];

    if (file && file.type === 'text/plain') {
      const reader = new FileReader();

      reader.onload = (event) => {
        const fileContent = event.target.result;
        if (typeof fileContent === 'string' && fileContent.trim().length > 0) {
          setFile(file);
          setErrorMessages([]);
          if (typeof fileContent === 'string' && fileContent.trim().length > 0) {
              // get manufacturer Id
              const getMfg = fileContent.match(/([A-Za-z]+)(\d{5})/);
              if (getMfg && getMfg[2]) {
                const mfgId = getMfg[2]; 
                setFile(file);
                setErrorMessages([]);
                setUploadMfgId(mfgId); 
              }    
          }    
        } else {
          setFile(null);
          setErrorMessages(['File is empty or invalid']);
        }
      };
      
    reader.onerror = () => {
      setFile(null);
      setErrorMessages(['Error reading file']);
    };
    reader.readAsText(file);

    } else {
      setFile(null);
      setErrorMessages(['Please enter a valid file format']);
    }

    e.currentTarget.value = null;
  });

  const validateFieldsBeforeUpload = () => {
    let error = [];
    let errorObj = {};

    const { error: headerError, errorObj: headerErrorObj } =
      validateHeaderFields(searchFilter);
        error = [...headerError];
        errorObj = { ...headerErrorObj };  
    if (!file) {
      error.push('File is required.');
    }
    if(searchFilter.dataContent !=='Multiple' && (searchFilter.priceType==null||searchFilter.priceType=="")){
      error.push(PRICE_TYPE_REQUIRED);
      errorObj.priceType=PRICE_TYPE_REQUIRED;
      }
    if(searchFilter.rpc==null||searchFilter.rpc==""){
      error.push(REBATE_PROGRAM_REQUIRED_REQ);
      errorObj.rpc=REBATE_PROGRAM_REQUIRED_REQ;
      }

    if (error.length > 0) {
      setErrorMessages(error);
      setFieldError(errorObj);
      return false;
    }
    setErrorMessages([]);
    setFieldError(null);
    return true;
  };

  const handleSubmit = () => {
    setErrorMessages([]);
    setSuccessMessages([]);

    // Local validation
    if (!validateFieldsBeforeUpload()) return;

    // API validation
    dispatch(
      getRequestDrugPriceLoadValidateFrozenInvoice(
        {
          ...searchFilter,
          planType:
            searchFilter.planType === 'ST' || searchFilter.planType === 'FD'
              ? 'G'
              : 'C',
          mfgId: uploadMfgId,    
        },
        () => {
          // On API validation success, upload file
          dispatch(
            getRequestDrugPriceLoadFileUpload(
              {
                ...searchFilter,
                planType:
                  searchFilter.planType === 'FD' ||
                  searchFilter.planType === 'ST'
                    ? 'G'
                    : 'C',
                multiPriceSelection: multiPriceSelectionRadioData[0].value,
                file,
              },
              () => {
                // On upload success, update filter and navigate
                dispatch(
                  setPriceLoadDetailsFilter({
                    ...searchFilter,
                    planType:
                      searchFilter.planType === 'FD' ||
                      searchFilter.planType === 'ST'
                        ? 'G'
                        : 'C',
                    multiPriceSelection: multiPriceSelectionRadioData[0].value,
                  })
                );
                navigateToPage(
                  '/RequestDrugPriceLoadDetails',
                  'Invoice Drug Price Detail'
                );
              },
              (message) => {
                setErrorMessages([message || ERR_PROCESSING_REQ]);
              },
              logInUser
            )
          );
        },
        (message) => {
          setErrorMessages([message]);
        }
      )
    );
  };

  return (
    <>
      <div className='row mt-2'>
        <div className='col-8'>
          <fieldset className='custom-fieldset'>
            <legend className='same-font-family'>Plan Type</legend>
            <div className='p-0 mt-2 row'>
              <div className='mui-custom-form col-12 m-0'>
                <RadioGroupComponentDLP
                  data={planTypeRadioData}
                  value={searchFilter && searchFilter.planType}
                  onChange={(_, value) => {
                    dispatch(setSearchFilter('rpc', null));
                    dispatch(setSearchFilter('planType', value));
                  }}
                  isEnablebyRole={isEnablebyRole}
                  radioGroupClassName='d-flex justify-content-between'
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-4'>
          <NDCDetailsTextFieldComponent
            label='Rebate Program'
            value={searchFilter && searchFilter.rpc}
            className='ml-0 with-select'
            select
            selectReset
            selectData={rebateProgramData}
            disabled={false}
            error={fieldError && fieldError.rpc}
            helperText={fieldError?.rpc ? fieldError?.rpc : ''}
            required
            onChange={(e) => {
              if (e.target.value === -1) {
                dispatch(setSearchFilter('rpc', null));
              } else {
                dispatch(setSearchFilter('rpc', e.target.value));
              }
            }}
            onBlur={(e) => {
              const { error, errorObj } = validateHeaderFields(
                searchFilter,
                'rpc',
                e.target.value
              );
              setErrorMessages(error);
              setFieldError(errorObj);
            }}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-8'>
          <fieldset className='custom-fieldset'>
            <legend className='same-font-family'>Data Content</legend>
            <div className='p-0 mt-2 row'>
              <div className='mui-custom-form col-12 m-0'>
                <RadioGroupComponentDLP
                  radioGroupClassName='justify-content-start'
                  data={dataContentRadioData}
                  value={searchFilter && searchFilter.dataContent}
                  labelClassName='dpl-radio-margin-left'
                  onChange={(_, value) => {
                    dispatch(setSearchFilter('dataContent', value));
                    if (value === dataContentRadioData[1]?.value) {
                      dispatch(setSearchFilter('priceType', null));
                    }
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        {searchFilter.dataContent === dataContentRadioData[0].value && (
          <div className='col-4'>
            <OverlayTrigger
              placement='bottom'
              overlay={
                searchFilter && searchFilter.priceType && priceTypeData ? (
                  <Tooltip id='labeler-tooltip'>
                    {priceTypeData.find(
                      (item) => item.value === searchFilter.priceType
                    )?.longDescr || ''}
                  </Tooltip>
                ) : (
                  <span></span>
                )
              }
            >
              <NDCDetailsTextFieldComponent
                label='Price Type'
                value={searchFilter && searchFilter.priceType}
                error={fieldError && fieldError.priceType}
                helperText={fieldError?.priceType ? PRICE_TYPE_REQUIRED : ''}
                className='ml-0 with-select'
                select
                selectReset
                selectData={priceTypeData}
                disabled={false}
                required
                onChange={(e) => {
                  if (e.target.value === -1) {
                    dispatch(setSearchFilter('priceType', null));
                  } else {
                    dispatch(setSearchFilter('priceType', e.target.value));
                  }
                }}
                onBlur={(e) => {
                  const { error, errorObj } = validateHeaderFields(
                    searchFilter,
                    'priceType',
                    e.target.value
                  );
                  setErrorMessages(error);
                  setFieldError(errorObj);
                }}
              />
            </OverlayTrigger>
          </div>
        )}
      </div>
      <div className='row mt-2'>
        <div className='col-8'>
          <fieldset className='custom-fieldset'>
            <legend className='same-font-family'>Data Source</legend>
            <div className='p-0 mt-2 row'>
              <div className='mui-custom-form col-12 m-0'>
                <RadioGroupComponentDLP
                  data={dataSourceRadioData}
                  value={searchFilter && searchFilter.dataSource}
                  onChange={(_, value) => {
                    dispatch(setSearchFilter('dataSource', value));
                  }}
                  disabledValues={
                    !isEnablebyRole
                      ? [
                          dataSourceRadioData[0].value,
                          dataSourceRadioData[2].value,
                        ]
                      : []
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-4'>
          <NDCDetailsTextFieldComponent
            maxLength={6}
            label='Calculated Quarter'
            value={quater}
            className='ml-0 mb-0'
            disabled={false}
            error={fieldError && fieldError?.calcQtr}
            helperText={fieldError && fieldError?.calcQtr}
            onChange={(e) => {
              const value = e.target.value.toUpperCase();
              if (/^[0-9Q]*$/.test(value)) {
                setQuater(value);
              } else {
                setQuater(value);
              }
            }}
            onBlur={(e) => {
              let { value } = e.target;
              if (value && checkQuaterIsValid(value)) {
                value = formatQuater(value);
              }
              const { error, errorObj } = validateHeaderFields(
                searchFilter,
                'calcQtr',
                value
              );
              setErrorMessages(error);
              setFieldError(errorObj);
              setQuater(value);
              dispatch(setSearchFilter('calcQtr', value));
            }}
          />
        </div>
      </div>
      {searchFilter &&
        searchFilter.dataSource === dataSourceRadioData[2].value && (
          <div className='row'>
            <div className='col-12'>
              <fieldset className='custom-fieldset'>
                <div className='p-0 mt-2 d-flex align-items-end'>
                  <label className='m-0 hide-elm' htmlFor='file'>
                    <span>label</span>{' '}
                  </label>
                  <input
                    id="file"
                    type="file"
                    ref={fileInputRef}
                    onChange={hanldeFileUpload}
                    accept="text/plain"
                    style={{ display: 'none' }}
                  />
                   
                  <div className='col-5'>
                    <NDCDetailsTextFieldComponent
                      label='File Name'
                      value={(file && file.name) || null}
                      className='ml-0 mb-0'
                    />
                  </div>
                  <div className='col-7' style={{ marginLeft: '80px' }}>
                    <Button
                      className='btn btn-success btn-view'
                      onClick={() => {
                        if (fileInputRef && fileInputRef.current) {
                          fileInputRef.current.click();
                        }
                      }}
                    >
                      Choose File
                    </Button>
                    <Button
                      style={{ marginLeft: '20px' }}
                      className='btn btn-success btn-view'
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
    </>
  );
};

export default ReuestDrugPriceLoadSearchComponent;
